const paths = {
	home: '/',
	intro: {
		philosophy: '/intro/philosophy',
		turnKey: '/intro/turn-key',
		process: '/intro/process'
	},
	portfolio: '/portfolio',
	column: '/column',
	review: '/review',
	faq: '/faq',
	inquiry: '/inquiry'
};

export default paths;
